import type { RevelioPageId } from '../../components/PageConfigProvider/types';
import { hasPageScopedFilterGroup } from '../../utils/routing-helpers';
import {
  type ConsistencyKey,
  NO_PRIMARY_FILTER_KEY,
} from '../engine/filterGroupConsistency';

export const getConsistencyKey = ({
  revelioPageId,
  primaryFilterId,
}: {
  revelioPageId: RevelioPageId | string | undefined;
  primaryFilterId: string | undefined;
}): ConsistencyKey =>
  hasPageScopedFilterGroup(revelioPageId)
    ? revelioPageId
    : (primaryFilterId ?? NO_PRIMARY_FILTER_KEY);
